var React = require('react');

function VolumeHigh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.6423 8.47363L10.1686 15.2526H3.38965V25.421H10.1686L18.6423 32.1999V8.47363Z","fill":"white","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M26.3364 14.3379C27.925 15.9269 28.8174 18.0819 28.8174 20.3288C28.8174 22.5757 27.925 24.7306 26.3364 26.3197","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M32.3184 8.35449C35.4955 11.5326 37.2803 15.8424 37.2803 20.3363C37.2803 24.8301 35.4955 29.14 32.3184 32.3181","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

VolumeHigh.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = VolumeHigh;

VolumeHigh.default = VolumeHigh;
